export default class BaseComponent {

    constructor(id, component_name, options = {}, extra_params = {}) {
        this.id = id;
        this.component_name = component_name;
        let component = document.getElementById('wrapper_' + this.id);
        this.options = options;
        this.extra_params = extra_params;
        
        if (component) {
            this.component = component
        };
        this.initialize();
    }

    // Called when the component is first created.
    initialize() {}

    find(selector) {
        return $(this.component).find(selector);
    }

    // Called when the component is removed from the page.
    finalize() {}

    // Called when the component has been loaded onto the page.
    onLoad() {}

    // Called once *all* components have bee loaded onto the page.
    onReady() {}

    // Functions exposed by the component (call via componentLocator.f.functionName(arg, ar2).
    functions() {
        return {};
    }

    // Called to remove the object from the page. Usually best left as-is.
    dismount() {
        this.component.innerHTML = '';
    }

    // Loads the component onto the page (calling the controller).
    // Use for deferred or updated components.
    rerender(asRerender = true) {
        window.__componentAdapter.render(this.id, asRerender);
    }

    // Sets an extraParam value for the component (injected via constructor).
    setParam(key, value) {
        window.__componentAdapter.setExtraParam(this.id, key, value);
    }
}
